import { render, staticRenderFns } from "./dispatcherNotification.vue?vue&type=template&id=7ff4d110&scoped=true&"
import script from "./dispatcherNotification.vue?vue&type=script&lang=js&"
export * from "./dispatcherNotification.vue?vue&type=script&lang=js&"
import style0 from "./dispatcherNotification.vue?vue&type=style&index=0&id=7ff4d110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4d110",
  null
  
)

export default component.exports